import React from 'react'
import { Collapsible } from '@foodsby/nutrient'
import cn from 'classnames'

// questions that are not required go into a collapse panel
export const QuestionCollapse = ({
  children,
  question,
  className,
  menuItemForEdit,
  isEditingOrder,
}) => {
  return (
    <Collapsible
      className={className}
      id={question.id}
      open={menuItemForEdit && !!menuItemForEdit[`q_${question.id}`]}
      trigger={
        <h2 className="segment-title menu-title">
          {question.text}
          {question.depth > 2 ? ' (Based on Selection above)' : ''}
        </h2>
      }
    >
      {question.description && <p>{question.description}</p>}
      {children}
    </Collapsible>
  )
}

export const QuestionRequired = ({
  children,
  question,
  className,
  valid,
  isRadio,
}) => {
  return (
    <div className={className} id={question.id}>
      {question.text && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <h2
            className={cn({
              'segment-title': true,
            })}
          >
            {question.text}
            {!isRadio && question.minimumSelection && (
              <div className="select-amount">
                Choose {question.minimumSelection}
                {question.maximumSelection > question.minimumSelection &&
                  ` - ${question.maximumSelection}`}
              </div>
            )}
            {question.depth > 2 ? ' (Based on Selection above)' : ''}
          </h2>
          <p>&nbsp;(required)</p>
        </div>
      )}
      {question.description && <p>{question.description}</p>}
      {children}
    </div>
  )
}

export const MenuQuestion = ({
  children,
  question,
  className,
  menuItemForEdit,
  isEditingOrder,
  isRadio,
  valid,
}) => {
  return (
    <div>
      <section
        className={`segment${question.depth >= 2 ? ' segment-child' : ''}`}
      >
        {question.minimumSelection > 0 ? (
          <QuestionRequired
            className={className}
            isRadio={isRadio}
            question={question}
            valid={valid}
          >
            {children}
          </QuestionRequired>
        ) : (
          <QuestionCollapse
            className={className}
            isEditingOrder={isEditingOrder}
            menuItemForEdit={menuItemForEdit}
            question={question}
          >
            {children}
          </QuestionCollapse>
        )}
      </section>
    </div>
  )
}

export default MenuQuestion
